import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
declare var window;
@Injectable()
export class MapsService {
  url="";
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    
  }
  doSomethingGoogley(key) {
    this.url = 'https://maps.googleapis.com/maps/api/js?libraries=places&key=' + key + '&callback=__onGoogleLoaded';
    if (isPlatformBrowser(this.platformId)) {
      return new Promise((resolve) => {
        window['__onGoogleLoaded'] = (ev) => {
          resolve(window.gapi);
        };
        if (!window.google || !window.google.maps) {
          this.loadScript();
        }else{
          resolve(true)
        }
      });
    }
    return new Promise(r=>{});
  }
  loadScript() {
    if (isPlatformBrowser(this.platformId)) {
      const node = document.createElement('script');
      node.src = this.url;
      node.type = 'text/javascript';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }
}
